import { render, staticRenderFns } from "./ActivarTicketConfigs.vue?vue&type=template&id=07c4030d"
import script from "./ActivarTicketConfigs.vue?vue&type=script&lang=js"
export * from "./ActivarTicketConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07c4030d')) {
      api.createRecord('07c4030d', component.options)
    } else {
      api.reload('07c4030d', component.options)
    }
    module.hot.accept("./ActivarTicketConfigs.vue?vue&type=template&id=07c4030d", function () {
      api.rerender('07c4030d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/invoices/components/ActivarTicketConfigs.vue"
export default component.exports